<app-title-percentage [title]="title" [percentage]="(praticaProgressService.progress$ | async)?.score">
</app-title-percentage>

<div style="margin-bottom: 2rem;">

  <mat-accordion>
    <mat-expansion-panel class="mat-elevation-z1 sagitta-score-accordion score-recap-panel" hideToggle>
      <mat-expansion-panel-header style="height: unset; padding: 24px 24px;">
        <mat-panel-title>

          <div>
            <div class="flex items-center" style="margin-bottom: 1rem;">
              <span class="bold" style="text-transform: uppercase;">Score complessivo:</span>
              <span class="bold" style="margin: 0 10px;">{{sagittaScore?.overallScore |
                number :
                '1.0-2'}}</span>
              <div [ngClass]="sagittaScore?.overallEvaluation"
                style="height: 1.2rem; width: 1.2rem; border-radius: 50%;">
              </div>
            </div>
            <div class="flex items-center">
              <span class="bold" style="text-transform: uppercase;">Score complessivo + ESG:</span>
              <span class="bold" style="margin: 0 10px;">{{sagittaScore?.overallEsgScore |
                number :
                '1.0-2'}}</span>
            </div>

          </div>
        </mat-panel-title>
        <mat-panel-description class="gradient-button-container">
          <div aria-hidden></div>
          <mat-icon svgIcon="info"></mat-icon>
        </mat-panel-description>
      </mat-expansion-panel-header>
      <div>
        <table mat-table [dataSource]="dataSource" class="table score-evalution-table">

          <ng-container matColumnDef="evaluation">
            <td mat-cell *matCellDef="let element"> {{element.evaluation | label}} </td>
          </ng-container>

          <ng-container matColumnDef="range">
            <td mat-cell *matCellDef="let element"> {{element.range}} </td>
          </ng-container>

          <ng-container matColumnDef="color">
            <td mat-cell *matCellDef="let element">
              <div style="height: 1rem;  width: 1rem; border-radius: 50%;" [ngClass]="element.evaluation"></div>
            </td>
          </ng-container>

          <ng-container matColumnDef="header">
            <th mat-header-cell *matHeaderCellDef style="text-align: center;" colspan="3">
              Scala di valutazione complessiva
            </th>
          </ng-container>


          <tr mat-header-row *matHeaderRowDef="['header']" style="height: 32px;"></tr>

          <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height: 32px;">
          </tr>
        </table>

      </div>
    </mat-expansion-panel>

  </mat-accordion>




</div>


<mat-accordion displayMode="flat" [multi]="true" class="sagitta-score-accordion">
  <ng-container *ngFor="let area of sagittaScore?.areas">
    <mat-expansion-panel hideToggle class="mat-elevation-z0">
      <mat-expansion-panel-header class="primary-border">
        <mat-panel-title>
          <div class="flex justify-between items-center w-full">
            <span>{{area.title}}</span>
            <div *ngIf="area.area !== 'A'" class="rounded" style="border: 2px solid; padding: 5px 10px">{{area.total |
              number : '1.0-2'}}</div>
            <!-- <div class="rounded" style="border: 2px solid; padding: 5px 10px">{{area.contributionToScoreComplessivo |
              number : '1.0-2'}}</div> -->

          </div>
        </mat-panel-title>
      </mat-expansion-panel-header>
      <div *ngFor="let section of area.sections">
        <div class="flex justify-between items-center" style="margin: 1rem 0;">
          <span>{{section.title}}</span>
        </div>
        <div class="rows-container">
          <div *ngFor="let row of section.rows; index as i" class="flex justify-between items-center row">
            <div class="flex-1 description-box">{{row.description}}</div>
            <div class="flex-3">
              <div *ngFor="let element of row.elements"
                class="flex  flex-wrap justify-between items-center sagitta-score-field-container">
                <div class="flex-3" *ngIf="element.description">{{element.description}}</div>
                <div class="flex-1">
                  <smart-form [fields]="[[element.field]]"></smart-form>
                </div>
                <div *ngIf="area.area !== 'A'" style="margin-left: 3rem">
                  <div class="rounded" style="border: 2px solid; padding: 5px 10px">
                    {{element.kriPoints | number : '1.0-2'}}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex justify-end items-start">
          <div class="primary-bg section-total-box">
            <span>Totale: </span>
            <span>
              {{section.total | number : '1.0-2'}}
            </span>
          </div>

        </div>
        <div class="notes">
          <ng-container *ngIf="section.notes">
            <smart-form [fields]="[[section.notes]]"></smart-form>
          </ng-container>
        </div>
      </div>
      <div class="flex justify-end">
        <div *ngIf="area.area === 'A'" class="primary-bg rounded"
          style="padding: 10px; width: fit-content; margin-top: 1rem;">
          <span>Condizioni verificate: </span>
          <span>{{area.total + '/' + area.elementCounter}}</span>
        </div>
      </div>

    </mat-expansion-panel>


  </ng-container>
</mat-accordion>